import React from "react";
import { IPrimaryUser } from "services/api/api.types";

import {
  FreeUserMobileDivider,
  FreeUserMobileFeatureBlockCTA,
  FreeUserMobileFeatureBlockDetails,
  FreeUserMobileFeatureBlockHeading,
  FreeUserMobileFeatureBlockImage,
  FreeUserMobileFeatureBlockImageWrapper,
  FreeUserMobileFeatureBlockLink,
  FreeUserMobileHeading,
  FreeUserMobileSection,
  FreeUserMobileFeatureBlock,
  LiveClassMobileBannerContainer,
  FreeUserMobileHeading1,
  FreeUserMobileHeading2,
  StyledButton,
  TryLiveClassMessageContainer,
  TryLiveClassMessageHeading,
  ActivateTrialButton,
  TryLiveClassMessageImage,
  FreeUserMobileContainer
} from "./free-user-mobile.styles";
import Image from "next/legacy/image";
import LiveClassMockup from "public/assets/kelas-live/live-classes-web-mobile.png";
import TryLiveClassImage from "public/assets/kelas-live/try-live-classes.svg";
import { Container } from "styles/common/container";
import { Spacer } from "styles/common/spacer";
import {
  SubscriptionStatus,
  SubscriptionType
} from "services/api/sessions/sessionService.types";
import { UserNoticeMobile } from "../user-notice/user-notice-mobile";
import {
  TrialActivationComponent,
  TrialActivationState
} from "../trial-activation-modal/trial-activation-modal.types";
import LiveClassMobileBanner from "../assets/live-class-mobile-banner.png";
import { useRouter } from "next/router";
import { TrialActivationMessage } from "../trial-activation-modal/trial-activation-message";
import { useUserLanding } from "../hooks/use-user-landing/use-user-landing";
import { NPSModal } from "components/nps/nps-modal/nps-modal";

const FreeUserMobile: React.FC<{
  primaryUser: IPrimaryUser;
  userSubscriptionStatus: SubscriptionStatus;
}> = ({ primaryUser, userSubscriptionStatus }) => {
  const userSubscriptionType = userSubscriptionStatus?.subscriptionType;
  const trialDuration = userSubscriptionStatus?.daysLeft;
  const {
    activationState,
    showTrialActivationComponent,
    activateTrial,
    showTrialActivation,
    setShowTrialActivation,
    isNpsModalOpen,
    feedbackTrialClassDataObject,
    handleNpsModalClose
  } = useUserLanding(primaryUser, userSubscriptionStatus);

  const router = useRouter();

  const handleClick = () => {
    if (userSubscriptionType === SubscriptionType.FREE) {
      setShowTrialActivation.on();
    } else {
      router.push({ pathname: "/paket" });
    }
  };

  return (
    <>
      {(activationState &&
        activationState === TrialActivationState.TRIAL_ACTIVATED &&
        userSubscriptionType === SubscriptionType.FREE) ||
      userSubscriptionType === SubscriptionType.TRIAL ? (
        <>
          <UserNoticeMobile
            primaryUser={primaryUser}
            subscriptionStatus={userSubscriptionStatus}
            activationState={activationState}
          />
          <FreeUserMobileSection>
            <Image
              src={LiveClassMockup}
              alt="Live Classes on app and laptop"
              layout="intrinsic"
            />
            <Container>
              <FreeUserMobileHeading>
                CoFriends bisa ikut Kelas Live di laptop atau HP, loh!
              </FreeUserMobileHeading>
              <Spacer token={[24, 24, 24]} />
              <FreeUserMobileFeatureBlock>
                <FreeUserMobileFeatureBlockImageWrapper>
                  <FreeUserMobileFeatureBlockImage
                    src="/assets/kelas-live/colearn-laptop.svg"
                    alt="Colearn on laptop"
                  />
                </FreeUserMobileFeatureBlockImageWrapper>
                <FreeUserMobileFeatureBlockDetails>
                  <FreeUserMobileFeatureBlockHeading>
                    Masuk ke website Kelas Live di laptop
                  </FreeUserMobileFeatureBlockHeading>
                  <FreeUserMobileFeatureBlockLink>
                    colearn.id/bimbel
                  </FreeUserMobileFeatureBlockLink>
                </FreeUserMobileFeatureBlockDetails>
              </FreeUserMobileFeatureBlock>
              <Spacer token={[24, 24, 24]} />
              <FreeUserMobileDivider>atau</FreeUserMobileDivider>
              <Spacer token={[24, 24, 24]} />
              <FreeUserMobileFeatureBlock>
                <FreeUserMobileFeatureBlockImageWrapper>
                  <FreeUserMobileFeatureBlockImage
                    src="/assets/kelas-live/colearn-mobile.svg"
                    alt="Colearn on mobile"
                  />
                </FreeUserMobileFeatureBlockImageWrapper>
                <FreeUserMobileFeatureBlockDetails>
                  <FreeUserMobileFeatureBlockHeading>
                    Masuk ke Kelas Live di aplikasi CoLearn
                  </FreeUserMobileFeatureBlockHeading>
                  <FreeUserMobileFeatureBlockCTA href="https://colearn.app.link/DownloadCoLearn">
                    Download Colearn
                  </FreeUserMobileFeatureBlockCTA>
                </FreeUserMobileFeatureBlockDetails>
              </FreeUserMobileFeatureBlock>
              <Spacer token={[24, 24, 24]} />
            </Container>
          </FreeUserMobileSection>
        </>
      ) : (
        <>
          <LiveClassMobileBannerContainer>
            <Image
              layout="responsive"
              src={LiveClassMobileBanner}
              alt="Login Mobile Background"
            />
            <FreeUserMobileContainer>
              <FreeUserMobileHeading1>
                Hi, {primaryUser.full_name}
              </FreeUserMobileHeading1>
              <FreeUserMobileHeading2>
                {userSubscriptionType === SubscriptionType.FREE &&
                  "Kamu belum langganan paket, nih. Coba gratis Kelas Live dulu aja!"}
                {userSubscriptionType === SubscriptionType.FREE_AFTER_PAID &&
                  "Periode paketmu udah abis. Langganan lagi yuk, biar bisa lanjut belajar bareng!"}
                {userSubscriptionType === SubscriptionType.FREE_AFTER_TRIAL &&
                  "Coba gratis Kelas Live udah abis. Langganan paket yuk, biar bisa lanjut belajar lagi!"}
              </FreeUserMobileHeading2>
              <StyledButton variant="secondary" onClick={handleClick}>
                {userSubscriptionType === SubscriptionType.FREE &&
                  "Coba gratis Kelas Live"}
                {(userSubscriptionType === SubscriptionType.FREE_AFTER_PAID ||
                  userSubscriptionType === SubscriptionType.FREE_AFTER_TRIAL) &&
                  "Eksplor paket belajar"}
              </StyledButton>
            </FreeUserMobileContainer>
          </LiveClassMobileBannerContainer>
          {userSubscriptionType === SubscriptionType.FREE && (
            <TryLiveClassMessageContainer>
              <TryLiveClassMessageImage>
                <Image
                  src={TryLiveClassImage}
                  alt="Try live classes"
                  layout="responsive"
                  priority
                />
              </TryLiveClassMessageImage>
              <TryLiveClassMessageHeading>
                Coba gratis Kelas Live {trialDuration} hari dan eksplor
                keseruannya!
              </TryLiveClassMessageHeading>
              <ActivateTrialButton variant="primary" onClick={handleClick}>
                Coba gratis dulu
              </ActivateTrialButton>
            </TryLiveClassMessageContainer>
          )}
          {showTrialActivation &&
            showTrialActivationComponent ===
              TrialActivationComponent.TRIAL_ACTIVATION_MESSAGE && (
              <TrialActivationMessage
                onClose={() => setShowTrialActivation.off()}
                activateTrial={activateTrial}
              />
            )}
        </>
      )}
      <>
        {feedbackTrialClassDataObject?.id && (
          <NPSModal
            feedbackTrialClassDataObject={feedbackTrialClassDataObject}
            isOpen={isNpsModalOpen}
            onClose={handleNpsModalClose}
          />
        )}
      </>
    </>
  );
};

export { FreeUserMobile };
